import React, { useState } from "react";
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import { API } from "../../common/Constants";
import { API_BASE_URL } from "../../environment";
import { analyticsService } from "../../services/analyticsService";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [formStatus, setFormStatus] = useState({
    submitting: false,
    submitted: false,
    error: false,
    errorMessage: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({
      submitting: true,
      submitted: false,
      error: false,
      errorMessage: "",
    });

    try {
      const response = await fetch(`${API_BASE_URL}${API.CONTACT_FORM}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to send message");
      }

      // Track successful contact form submission
      analyticsService.trackEvent(
        'Contact',
        'Form Submission',
        `Subject: ${formData.subject}`,
        1
      );

      setFormStatus({
        submitting: false,
        submitted: true,
        error: false,
        errorMessage: "",
      });
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      console.error("Error sending contact form:", error);
      setFormStatus({
        submitting: false,
        submitted: false,
        error: true,
        errorMessage:
          error.message || "Failed to send message. Please try again.",
      });
    }
  };

  return (
    <section id="contact" className="contact section-padding">
      <div className="container">
        <div className="section-header">
          <h2>Contact Us</h2>
          <p>Get in touch with our support team</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-info-item">
              <div className="contact-info-icon">
                <FaEnvelope />
              </div>
              <div className="contact-info-text">
                <h3>Email</h3>
                <p>pathshalasanchalak@gmail.com</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon">
                <FaPhone />
              </div>
              <div className="contact-info-text">
                <h3>Phone</h3>
                <p>+91 7457804496</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-icon">
                <FaMapMarkerAlt />
              </div>
              <div className="contact-info-text">
                <h3>Address</h3>
                <p>291/4 Jagriti Vihar, Meerut, Uttar Pradesh, India</p>
              </div>
            </div>

            {/* In a real application, you would embed a map here */}
            {/* <div className="contact-map">
              <div className="map-placeholder">
                <p>Map</p>
              </div>
            </div> */}
          </div>

          <div className="contact-form-container">
            <h3>
              <label>We're Here to Help</label>
              <span>Send a Message or Request a Demo</span>
            </h3>
            
            

            {formStatus.submitted ? (
              <div className="success-message">
                <p>Thank you for your message! We'll get back to you soon.</p>
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    setFormStatus({
                      submitting: false,
                      submitted: false,
                      error: false,
                    })
                  }
                >
                  Send another message
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                {formStatus.error && (
                  <div className="error-alert">
                    <p>
                      {formStatus.errorMessage ||
                        "Failed to send message. Please try again."}
                    </p>
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="name">Your Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Your Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={formStatus.submitting}
                >
                  {formStatus.submitting ? "Sending..." : "Send Message"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
